import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-version',
    templateUrl: './version.component.html'
})

export class VersionComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}